import Order from '@/zenky/interfaces/orders/Order';
import AbstractDatatable from '@/zenky/datatables/AbstractDatatable';
import DatatableColumn from '@/zenky/datatables/DatatableColumn';
import DatatableHeader from '@/zenky/datatables/DatatableHeader';
import OrdersDatatableComponent from '@/components/resources/orders/OrdersDatatable.vue';
import config from '@/../config/zenky';
import CityFilter from '@/zenky/datatables/filters/orders/CityFilter';
import DeliveryMethodFilter from '@/zenky/datatables/filters/orders/DeliveryMethodFilter';
import StatusFilter from '@/zenky/datatables/filters/orders/StatusFilter';

export default class OrdersDatatable extends AbstractDatatable {
  getComponentName(): any {
    return OrdersDatatableComponent;
  }

  baseApiUrl(): string {
    return `orders?with=${config.api.includes.orders.list}`;
  }

  headers(): DatatableHeader[] {
    return [
      new DatatableHeader('number', 'Номер').withResponsiveClass('all'),
      new DatatableHeader('customer', 'Получатель').withResponsiveClass('all'),
      new DatatableHeader('payment', 'Оплата').withResponsiveClass('all'),
      new DatatableHeader('stock', 'Склад').withResponsiveClass('all'),
      new DatatableHeader('delivery', 'Доставка').withResponsiveClass('all'),
      new DatatableHeader('city', 'Город').withResponsiveClass('all'),
    ];
  }

  columns(): DatatableColumn[] {
    return [];
  }

  filters() {
    return [
      new CityFilter(),
      // new PaymentFilter(),
      new DeliveryMethodFilter(),
      new StatusFilter(),
    ];
  }

  actions(order: Order): any[] {
    return [
      this.editRouteAction({
        name: 'orders.edit',
        params: {
          id: order.id,
        },
      }),
    ];
  }
}
